import { SidebarCloseIcon } from '@assets/icons/SidebarCloseIcon';
import { cn } from '@components/shadcn/utils';
import { Button } from 'antd-v6';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useMatch, useOutlet } from 'react-router-dom';
import { Actions } from '../../redux/actions';
import type { RootState } from '../../redux/reducers';
import { routePaths } from '../../screens/routes';

const { toggleActionDrawer } = Actions;

interface IActionDrawerProps {
  readonly drawerComponent?: React.JSX.Element;
}

export function ActionDrawer({ drawerComponent }: IActionDrawerProps) {
  const dispatch = useDispatch();
  const { actionDrawerCollapsed } = useSelector((state: RootState) => state.App);

  const outlet = useOutlet();
  const isCreatingPrescription = useMatch(routePaths.prescriptionsCreate);

  return (
    <aside className="relative flex h-[calc(100vh-3.31rem)] border-r border-sy-neutral-20 bg-white">
      <div className="relative">
        <div
          className={classNames(
            'h-full w-80 bg-white transition-[width,opacity] duration-[250ms]',
            {
              '!w-4 opacity-0': actionDrawerCollapsed,
            }
          )}
        >
          {drawerComponent}
        </div>

        <Button
          onClick={() => dispatch(toggleActionDrawer())}
          data-testid="action-drawer-collapse-button"
          className={cn('absolute top-6 right-2 rounded-full bg-white border-none', {
            '-right-4': actionDrawerCollapsed,
          })}
          icon={
            <SidebarCloseIcon
              fill="#696F88"
              width={18}
              height={18}
              className={cn('transition-transform duration-[250ms]', {
                'rotate-180': actionDrawerCollapsed,
              })}
            />
          }
        />
      </div>

      <div
        className={classNames('h-full w-80 bg-white', {
          relative: isCreatingPrescription,
          'absolute inset-y-0 left-0 z-10 overflow-hidden transition-transform duration-[250ms]': !isCreatingPrescription,
          '-translate-x-full': !isCreatingPrescription && !outlet,
        })}
      >
        {outlet}
      </div>
    </aside>
  );
}

export default ActionDrawer;
